import { ModelSnapshot } from '@deqo/podopolis';
import { ApiCall } from '../ApiClient';
import { ResultData } from '../ApiTypes';

const get = <TResponse>(def: Omit<ApiCall<never, TResponse>, 'method'>): ApiCall<never, TResponse> =>
    Object.assign(def, { method: 'get' });

const post = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'post' });

const put = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'put' });

export interface PodTransactionData {
    readonly podId: string;
    readonly time: number;
    readonly userId: string;
    readonly version: number;
    readonly writes: any[][];
}

export interface PodTransactionStats {
    readonly podId: string;
    readonly count: number;
}

export const podsEndpoints = {

    hydrate: (podId: string, recordSet: string, loader: string) => post<ResultData>({
        path: '/pods.hydrate',
        body: { podId, recordSet, loader },
    }),

    snapshots: (podId: string, type: 'initial' | 'latest') => get<ModelSnapshot>({
        path: '/pods.snapshots',
        query: { podId, type },
    }),

    transactionStats: (podId: string) => get<PodTransactionStats>({
        path: '/pods.transactionStats',
        query: { podId },
    }),

    transactions: (podId: string, skip: number, take: number) => get<PodTransactionData[]>({
        path: '/pods.transactions',
        query: { podId, skip, take },
    }),

};
